/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import s from './DropDownNavigationList.scss';
import Link from '../../../components/Link/Link';

const DropDownNavigationList = props => {
  const { items } = props;

  return (
    <>
      {items &&
        Array.isArray(items) &&
        items.map(sec => (
          <li key={sec.label}>
            <Link to={sec.wu} data-ga={`Navbar_${sec.wu}/${sec.wu}`}>
              {sec.hl}
            </Link>
          </li>
        ))}
    </>
  );
};

DropDownNavigationList.propTypes = {
  items: PropTypes.objectOf([]),
};

DropDownNavigationList.defaultProps = {
  items: [],
};

export default DropDownNavigationList;
